(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template-with-product"]) return;
  try {
    
  $(document).ready(function(){
    // Regardless of stock, update the product price and finance quote
    var financeAmount = parseFloat($('#productPrice').html().replace(',','').replace('£',''));
    calculateFinance(financeAmount);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-template"]) return;
  try {
    
  $(document).ready(function(){
    // Regardless of stock, update the product price and finance quote
    var financeAmount = parseFloat($('#productPrice').html().replace(',','').replace('£',''));
    calculateFinance(financeAmount);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  $(document).ready(function(){
    // Regardless of stock, update the product price and finance quote
    var financeAmount = parseFloat($('#productPrice').html().replace(',','').replace('£',''));
    calculateFinance(financeAmount);
  });
  

  } catch(e) { console.error(e); }
})();
})();
